var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverAllNiddle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 57,
    viewBox: "0 0 10 57",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.07272 6.6786e-09L10 57L5 57L-7.50446e-08 57L5.07272 6.6786e-09Z",
    fill: "#206DC5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverAllNiddle);
export default __webpack_public_path__ + "static/media/overAllNiddle.b9ac2d82bd4d13c03411eeaf6fe7b854.svg";
export { ForwardRef as ReactComponent };